/**
 * @desc 修改sku默认供应商
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: Array<defs.basics.PlmSkuVendorRpcRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/updateSkuSupplier`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
